import {
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonLabel,
  IonSkeletonText
} from '@ionic/react';

import styles from './PricingCardLoadingCard.module.scss';

import { GitLiveLogo } from '../GitLiveLogo/GitLiveLogo';

export const PricingPlansLoadingCard = () => (
  <div className={styles.cardContainer}>
    <GitLiveLogo />
    <IonCard className={styles.card}>
      <IonCardHeader className={styles.cardHeader}>
        <IonCardTitle>
          <IonSkeletonText
            animated={true}
            style={{ width: '200px', height: '24px' }}
          />
        </IonCardTitle>
        <IonCardSubtitle>
          <IonSkeletonText
            animated={true}
            style={{ width: '300px', height: '16px' }}
          />
        </IonCardSubtitle>

        <IonSkeletonText
          className={styles.link}
          animated={true}
          style={{ width: '250px', height: '16px' }}
        />
      </IonCardHeader>

      <div className={styles.pricingContainer}>
        <div className={styles.planContainer}>
          <IonSkeletonText
            animated={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>

        <div className={styles.planContainer}>
          <IonSkeletonText
            animated={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>

        <div className={styles.planContainer}>
          <IonSkeletonText
            animated={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <IonSkeletonText
          animated={true}
          style={{ width: '100%', height: '32px' }}
        />

        <hr />
        <IonLabel>
          <IonSkeletonText
            animated={true}
            style={{ width: '350px', height: '16px' }}
          />
        </IonLabel>
      </div>
    </IonCard>
  </div>
);
